import { isValidObject, LILAC_200, tokens, WHITE } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getStepWidgetStyles = (isSmallScreen, internalIsExpanded, props) => {
  var _tokens$spacing = tokens.spacing,
    SPACING_4 = _tokens$spacing.SPACING_4,
    SPACING_8 = _tokens$spacing.SPACING_8,
    SPACING_12 = _tokens$spacing.SPACING_12,
    SPACING_16 = _tokens$spacing.SPACING_16,
    SPACING_24 = _tokens$spacing.SPACING_24;
  var borderRadiusToken = tokens.borderRadius.BORDER_RADIUS_16;
  var planListWidgetData = props.planListWidgetData,
    _props$backgroundColo = props.backgroundColor,
    backgroundColor = _props$backgroundColo === void 0 ? LILAC_200 : _props$backgroundColo;
  return StyleSheet.create({
    stepCard: Object.assign({
      borderRadius: borderRadiusToken,
      borderColor: WHITE,
      width: '100%',
      backgroundColor
    }, isValidObject(planListWidgetData) && isSmallScreen && {
      overflow: 'hidden'
    }),
    collapsibleContainer: {
      width: '100%'
    },
    linkListWidget: {
      borderRadius: borderRadiusToken,
      backgroundColor
    },
    content: {
      padding: SPACING_16
    },
    omni: {
      marginHorizontal: -SPACING_16
    },
    planList: Object.assign({
      paddingHorizontal: isSmallScreen ? tokens.spacing.SPACING_0 : tokens.spacing.SPACING_16
    }, !(planListWidgetData === null || planListWidgetData === void 0 ? void 0 : planListWidgetData.showExpandCta) && !isValidObject(planListWidgetData === null || planListWidgetData === void 0 ? void 0 : planListWidgetData.expandCtaData) && {
      marginBottom: isSmallScreen ? -SPACING_16 : -SPACING_24
    }),
    titleComponent: {
      width: '100%',
      paddingVertical: SPACING_4
    },
    calloutContainer: Object.assign(Object.assign({}, !internalIsExpanded && {
      marginBottom: SPACING_12
    }), {
      marginHorizontal: SPACING_16,
      marginTop: SPACING_8
    })
  });
};